/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Material_Save_SuccessInputs */

const vi_agri_material_save_success = /** @type {(inputs: Agri_Material_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu vật tư nông nghiệp`)
};

/**

* @param {Agri_Material_Save_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_material_save_success = /** @type {((inputs?: Agri_Material_Save_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Material_Save_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_material_save_success(inputs)
});